module.exports = __webpack_public_path__ + "static/media/hero-banner.29cf2e39.png";